import { Grid, TextField } from "@mui/material";

const BankDetailsStep = ({ values, handleChange, handleBlur, errors, touched }) => (
  <Grid container spacing={2}>
    {[
      { name: "bank_name", label: "Bank Name" },
      { name: "account_number", label: "Account Number" },
      { name: "ifsc_code", label: "IFSC Code" },
      { name: "pan_number", label: "PAN Number" },
      { name: "pf_number", label: "PF Number" },
      { name: "esi_number", label: "ESI Number" },
    ].map(({ name, label }) => (
      <Grid item xs={12} sm={6} key={name}>
        <TextField
          fullWidth
          name={name}
          label={label}
          value={values[name] || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched[name] && Boolean(errors[name])}
          helperText={touched[name] && errors[name]}
        />
      </Grid>
    ))}
  </Grid>
);

export default BankDetailsStep;
